interface Claims {
  partner_id?: number
  permessi?: string[]
}

// Il token e' gia' verificato da Supabase; qui lo si legge solo per orientare la
// UI. Le decisioni di sicurezza restano nel database (RLS).
function decodifica(token: string): Claims {
  const parte = token.split('.')[1]
  if (!parte) return {}
  try {
    return JSON.parse(atob(parte.replace(/-/g, '+').replace(/_/g, '/'))) as Claims
  } catch {
    return {}
  }
}

export function partnerIdDaToken(token: string | undefined): number | undefined {
  return token ? decodifica(token).partner_id : undefined
}

export function permessiDaToken(token: string | undefined): string[] {
  return token ? (decodifica(token).permessi ?? []) : []
}
